import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  SparklesIcon,
  PathIcon,
  LibraryIcon,
  UsersIcon,
  FileTextIcon,
  MegaphoneIcon,
  BarChartIcon,
} from "./icons";

const DashboardHome = () => {
  const { t } = useTranslation();

  const cardItems = [
    {
      title: t("admin.aiCurriculumAssistant"),
      icon: <SparklesIcon className="w-6 h-6 text-indigo-600" />,
      route: "curriculum",
    },
    {
      title: t("admin.learningPathDesigner"),
      icon: <PathIcon className="w-6 h-6 text-indigo-600" />,
      route: "paths",
    },
    {
  title: t("admin.feesManagement"),
  icon: <BarChartIcon   className="w-6 h-6 text-indigo-600" />,
  route: "fees-management",
},

    // {
    //   title: t("admin.comprehensiveAnalytics"),
    //   icon: <BarChartIcon className="w-6 h-6 text-indigo-600" />,
    //   route: "analytics",
    // },
    {
      title: t("admin.staffAdministration"),
      icon: <UsersIcon className="w-6 h-6 text-indigo-600" />,
      route: "staff",
    },
    {
      title: t("admin.policyManagement"),
      icon: <FileTextIcon className="w-6 h-6 text-indigo-600" />,
      route: "policy",
    },
    {
      title: t("admin.announcements"),
      icon: <MegaphoneIcon className="w-6 h-6 text-indigo-600" />,
      route: "announcements",
    },
    {
      title: t("admin.libraryResource"),
      icon: <LibraryIcon className="w-6 h-6 text-indigo-600" />,
      route: "library",
    },
    {
      title: t("admin.subscription"),
      icon: <LibraryIcon className="w-6 h-6 text-indigo-600" />,
      route: "subscription",
    },
  ];

  return (
    <div>
      <div className="text-center mb-10">
        <h1 className="text-3xl font-bold text-gray-800">
          {t("admin.controlCenter")}
        </h1>
        <p className="text-base text-gray-500 mt-2">
          {t("admin.welcomeText")}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {cardItems.map((item, idx) => (
          <Link
            to={`${item.route}`}
            key={idx}
            className="group bg-gray-100 p-4 rounded-2xl shadow-sm hover:shadow-xl hover:bg-indigo-600 transition-all duration-300 transform hover:-translate-y-1 block text-left"
          >
            <div className="bg-indigo-100 group-hover:bg-white p-2 rounded-full inline-block transition-colors duration-300">
              {item.icon}
            </div>
            <h3 className="font-semibold text-gray-800 group-hover:text-white mt-3 text-sm transition-colors duration-300">
              {item.title}
            </h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DashboardHome;
